var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.193,
    height: 16.174,
    viewBox: "0 0 13.193 16.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M18852.143,19786.176a2.149,2.149,0,0,1-1.768-.9,2.029,2.029,0,0,1-.229-1.928,6.458,6.458,0,0,1,11.854,0,1.99,1.99,0,0,1-.215,1.928,2.186,2.186,0,0,1-1.777.9Zm.715-11.961a3.221,3.221,0,1,1,3.223,3.223A3.224,3.224,0,0,1,18852.857,19774.215Z",
    transform: "translate(-18849.482 -19770.502)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWhiteIcon);
export default __webpack_public_path__ + "static/media/accountWhiteIcon.b91ae2c5d922585da3e9d410ee979444.svg";
export { ForwardRef as ReactComponent };